import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import uuid from "react-uuid";
import axios from "axios";

import { ProductFormContainer } from "../../../../styled/setting";

import useUploadFiles from "../../../../../../../../hooks/useUploadFiles";

import ProductForm from "./productForm";
import Info from "../../../common/info";

const AddProduct = ({
  categoriesObj,
  openModal,
  closeModal,
  selectCompany,
  getProducts,
  setIsDetail,
  product,
  setProduct,
  closeForm,
  toggleModal,
  options,
  setOptions,
  changeSlide,
}) => {
  const { uploadFiles, uploadEmbedded } = useUploadFiles();

  // 옵션 ID 오름차순 여부 확인
  const isAscending = options.every((opt, i, arr) => (i === 0 ? true : opt.id >= arr[i - 1].id));

  // 파일 업로드
  const handleUpload = async () => {
    try {
      const media = product.media || [];

      const alreadyUploaded = media.filter((item) => !item.file);
      const toUpload = media.filter((item) => item.file).map((item) => item.file);
      const uploaded = toUpload.length ? await uploadFiles(toUpload) : [];

      const updatedDesc = await uploadEmbedded(product.description);

      const finalMedia = [
        ...alreadyUploaded.map((item) => ({ path: item.path })),
        ...uploaded.map((item) => ({ path: item.fileName })),
      ];

      return {
        media: finalMedia,
        description: updatedDesc,
      };
    } catch (error) {
      console.error("파일 업로드 중 오류 발생:", error);
      return { media: [], description: product.description };
    }
  };

  const handleUpdate = async () => {
    const uploadedData = await handleUpload();
    console.log(uploadedData);
    createProduct(uploadedData.media, uploadedData.description);
  };

  // 저장 버튼 클릭
  const handleSave = () => {
    if (!validationCheck()) return;

    openModal({
      type: "confirmation",
      title: "상품 추가",
      message: ["상품을 메뉴에 추가하시겠습니까?"],
      handleConfirm: handleUpdate,
    });
  };

  // 유효성 체크
  const validationCheck = () => {
    if (!product.name) {
      toast.error("상품명을 입력해주세요.");
      return false;
    }

    if (product.price === null || product.price === undefined || product.price === "") {
      toast.error("가격을 입력해주세요.");
      return false;
    }

    // if (!product.categoryId) {
    //   toast.error("카테고리를 선택해주세요.");
    //   return false;
    // }

    return true;
  };

  // 상품 생성
  const createProduct = async (files = [], description) => {
    try {
      const url = "/erp/cloudProducts/create";
      const body = {
        createCmpnyNo: selectCompany?.value,
        name: product?.name,
        description: description || " ",
        shortDescription: product?.shortDescription || "",
        brand: product?.brand,
        specifications: product?.specifications,
        categoryId: product?.categoryId,
        media: files.map((file) => file.path),
        quantity: toNumber(product?.quantity),
        basePrice: toNumber(product?.price),
      };

      const res = await axios.post(url, body);

      if (res.status === 200) {
        const data = res.data;
        syncProducts(data);
      }
    } catch (error) {
      console.error("업데이트 실패:", error.response?.data || error.message, error.stack);
    }
  };

  // 상품 연동
  const syncProducts = async (item) => {
    if (!item) return;

    const url = "/erp/vendorProducts/create";
    const body = {
      input: {
        cmpnyNo: selectCompany.value,
        cloudProductId: parseInt(item.id, 10),
        tags: product.tags,
        useDisplay: product.useDisplay,
        status: product.status,
        quantity: toNumber(product?.quantity),
        optionGroupIds: options.map((opt) => opt.id),
      },
    };

    try {
      const res = await axios.post(url, body);

      if (res.status === 200) {
        if (options && options.length > 0 && !isAscending) {
          await updateOptionOrder(res.data[0].id);
        }
        toast.success("상품이 등록되었습니다.", { toastId: "no-access" });
        await getProducts();
        closeForm();
      }
    } catch (error) {
      console.log(error);
      toast.error("잠시 후 다시 시도해주세요");
    } finally {
      closeModal();
    }
  };

  // 옵션 정렬 순서 저장
  const updateOptionOrder = async (id) => {
    try {
      const url = "/erp/vendorProduct/optionOrder";
      const body = {
        input: {
          vendorProductId: id,
          optionGroupOrders: options.map((opt, idx) => ({
            optionGroupId: opt.id,
            sortOrder: idx,
          })),
        },
      };
      await axios.post(url, body);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <ProductFormContainer>
      <Info
        message="상품 추가"
        actions={[
          {
            label: "취소",
            func: () =>
              openModal({
                type: "confirmation",
                title: "나가기",
                message: ["작업 중인 내용이 사라질 수 있습니다.", "저장하지 않고 나가시겠습니까?"],
                handleConfirm: closeForm,
              }),
            key: "cancel",
          },
          { label: "저장", func: handleSave, key: "add" },
        ]}
      />
      <ProductForm
        product={product}
        setProduct={setProduct}
        categoriesObj={categoriesObj}
        setIsDetail={setIsDetail}
        toggleModal={toggleModal}
        options={options}
        setOptions={setOptions}
        changeSlide={changeSlide}
      />
    </ProductFormContainer>
  );
};

export default AddProduct;
